import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BizUserDetails} from 'src/app/models/user';
import { Area } from 'src/app/models/area';

export const area = signal<Area | undefined>(undefined);
export const areas = signal<Area[]>([]);
export const userDetails = signal<BizUserDetails>({});
export const lgScreen = signal<boolean>(false);
export const uiMessage = signal<{ text: string, type: string } | null>(null);
export const businessCategories = signal<{key: string, value: string}[]>([
  { key: 'food', value: 'Mangiare e Bere' },
  { key: 'hosting', value: 'Dormire' },
  { key: 'dressing', value: 'Vestirsi' },
  { key: 'fun', value: 'Divertirsi' },
  { key: 'visiting', value: 'Visitare' },
  { key: 'localProducts', value: 'Prodotti Tipici' },
  { key: 'sport', value: 'Attività ricreative e Sport' },
  { key: 'culture', value: 'Cultura' },
  { key: 'wellness', value: 'Benessere' },
  { key: 'medical_devices', value: 'Dispositivi Medici' },
  { key: 'education', value: 'Istruzione' },
  { key: 'ticket', value: 'Ticket' },
  { key: 'transport', value: 'Trasporti' },
  { key: 'services', value: 'Servizi' },
  { key: 'other', value: 'Altro' }
]).asReadonly();
@Injectable({
  providedIn: 'root'
})
export class BreakpointObserverService {

  constructor(private responsive: BreakpointObserver,
    private http: HttpClient) {
    this.responsive.observe('(min-width: 1200px)')
      .subscribe(result => {
        if (result.matches) {
          lgScreen.set(true);
        } else {
          lgScreen.set(false);
        }
      });
  }
}